(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const setup = () => {
        this.header = document.querySelector('.section-header');
        if (!this.header) return;

        this.announcementBar = document.querySelector('.announcement-bar-section');
        this.headerIsAlwaysSticky =
          this.getAttribute('data-sticky-type') === 'always' ||
          this.getAttribute('data-sticky-type') === 'reduce-logo-size';
        /* Sentinel until IntersectionObserver runs — avoids scrollTop > undefined and bad thresholds */
        this.headerBounds = { top: 0, bottom: Number.POSITIVE_INFINITY, left: 0, right: 0, width: 0, height: 0 };

        this.setHeaderHeight();

        window.matchMedia('(max-width: 1200px)').addEventListener('change', this.setHeaderHeight.bind(this));

        if (this.headerIsAlwaysSticky) {
          this.header.classList.add('shopify-section-header-sticky');
          if (this.announcementBar) {
            this.announcementBar.classList.add('shopify-section-header-sticky');
          }
        }

        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector('predictive-search');

        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this._onHeaderSearchClosed = () => {
          if (this.headerIsAlwaysSticky) return;
          const st = window.pageYOffset || document.documentElement.scrollTop;
          this.currentScrollTop = st - 1;
          requestAnimationFrame(() => this.onScroll());
        };
        document.addEventListener('phe:header-search-closed', this._onHeaderSearchClosed);

        this.createObserver();
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', setup, { once: true });
      } else {
        setup();
      }
    }

    setHeaderHeight() {
      if (!this.header) return;
      const nav = this.querySelector('.header');
      /* sticky-header can be position:absolute (transparent index); .section-header then collapses — measure this or .header instead */
      let mainChrome =
        this.offsetHeight || (nav ? nav.offsetHeight : 0) || this.header.offsetHeight;
      let totalHeight = mainChrome;
      if (this.announcementBar) {
        const announcementHeight = this.announcementBar.offsetHeight;
        document.documentElement.style.setProperty('--announcement-bar-height', `${announcementHeight}px`);
        totalHeight += announcementHeight;
      } else {
        document.documentElement.style.setProperty('--announcement-bar-height', '0px');
      }
      document.documentElement.style.setProperty('--header-height', `${totalHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      document.removeEventListener('phe:header-search-closed', this._onHeaderSearchClosed);
    }

    createObserver() {
      if (!this.header) return;
      /* Dawn compares scrollTop to intersectionRect.bottom — must use intersectionRect, not boundingClientRect (mixed coordinate space). Prefer observing sticky-header when section wrapper has no layout height (transparent / absolute). */
      const applyEntry = (entry) => {
        let ir = entry.intersectionRect;
        if (ir.bottom > 0 || ir.height > 0 || ir.width > 0) {
          this.headerBounds = ir;
          return;
        }
        const nav = this.querySelector('.header');
        const h = Math.max(this.offsetHeight, nav ? nav.offsetHeight : 0, 48);
        this.headerBounds = { top: 0, bottom: h, left: 0, right: 0, width: 0, height: h };
      };

      const run = () => {
        const target = this.header.offsetHeight > 2 ? this.header : this;
        const observer = new IntersectionObserver(
          (entries, obs) => {
            applyEntry(entries[0]);
            obs.disconnect();
          },
          { threshold: [0, 1] }
        );
        observer.observe(target);
      };

      requestAnimationFrame(() => requestAnimationFrame(run));
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // Don't hide header/announcement bar if search modal is open
      const searchModal = document.querySelector('.header__search details[open]');
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (searchModal) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.setHeaderHeight();
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      if (this.announcementBar) {
        this.announcementBar.classList.add('shopify-section-header-sticky', 'shopify-section-header-hidden');
      }
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      if (this.announcementBar) {
        this.announcementBar.classList.add('shopify-section-header-sticky', 'animate');
        this.announcementBar.classList.remove('shopify-section-header-hidden');
      }
      this.setHeaderHeight();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      if (this.announcementBar) {
        this.announcementBar.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
